import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Page, PageHeader } from "@/components/app/page";
import { MakePackages } from "@/features/settings/make-packages";

export const Route = createFileRoute("/settings/packages")({
  component: MakePackagesPage,
});

/** Settings › Make packages (ADR 0014): kept off the Settings page, which is long enough. */
function MakePackagesPage() {
  const { t } = useTranslation();
  return (
    <Page>
      <PageHeader
        title={t("makePackages.title")}
        subtitle={t("makePackages.body")}
        crumbs={[{ label: t("settings.title"), to: "/settings" }]}
      />
      <div className="max-w-3xl">
        <MakePackages />
      </div>
    </Page>
  );
}
